<template>
  <div ref="button" class="button-dropdown loading" @mouseenter="showOptions" @mouseleave="mouseLeave">
      <div class="col">
        <div class="hover-button orange toggle"><span v-html="button.button_text"></span> <i class="fas fa-plus plus"></i></div>
      </div>
      <div class="col">
        <div ref="options" class="options">
            <div v-for="(item, index) in button.dropdown_options" :key="index">
                <a class="option" :href="item.option.url" :target="item.option.target"><span v-html="item.option.title"></span></a>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
    props: {
      button: {
          type: Object,
          required: true
      },
    },
    data() {
        return {
            optionsWidth: 0
        }
    },
    mounted() {
        this.calculateWidths();
    },
    methods: {
        calculateWidths() {
            this.optionsWidth = this.$refs.options.offsetWidth;
            this.$refs.button.classList.remove('loading');
        },
        showOptions : function() {
            var right = window.innerWidth - this.$refs.button.getBoundingClientRect().right;
            
            var bottom = this.$refs.options.getBoundingClientRect().bottom;
            var parentBottom = this.$refs.options.closest('.block').getBoundingClientRect().bottom;
            
            // If there is not enough space to display the element with an absolute position, display it relatively
            if ((right - this.optionsWidth < 0) || (bottom > parentBottom)) {
            //if (right - this.optionsWidth < 0) {
                this.$refs.options.classList.add('relative');
            } else {
                this.$refs.options.classList.remove('relative');
            }
        },
        mouseLeave: function() {
            this.$refs.options.classList.remove('relative');
        }
    }
}
</script>